import api from '@/api'

export const albumDeliveries = {
  methods: {
    async deliver(albumId) {
      return await api.albumDeliveries.create(albumId)
    }
  }
}
